<template>
  <div class="relative bg-white pt-16 pb-16">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div class="flex flex-wrap mt-6">
        <div class="w-full px-4">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
            <div class="rounded-t mb-0 px-6 py-3 border-0">
              <div class="flex flex-wrap items-center">
                <div class="relative w-full px-4 max-w-full flex-grow flex-1">
                  <h3 class="font-semibold text-base text-blueGray-700">{{ pageTitle }}</h3>
                </div>
              </div>
            </div>

            <div v-if="isCmsMode" class="block w-full px-6 pb-8">
              <section v-if="isCmsMenuMode" class="config-section">
                <div class="section-head cms-toolbar">
                  <div class="cms-actions">
                    <el-select v-model="cmsMenuFilter.page" placeholder="页面" style="width: 180px" @change="resetCmsMenuPage">
                      <el-option label="全部页面" value=""></el-option>
                      <el-option label="场景案例（/feature）" value="feature"></el-option>
                      <el-option label="功能介绍（/intro）" value="intro"></el-option>
                    </el-select>
                    <el-input
                      v-model="cmsMenuFilter.keyword"
                      clearable
                      placeholder="搜索菜单名称"
                      style="width: 220px"
                      @keyup.enter="resetCmsMenuPage"
                      @clear="resetCmsMenuPage"
                    ></el-input>
                    <el-button @click="queryCmsMenuData">刷新</el-button>
                  </div>
                  <el-button type="primary" :disabled="!canEditPage" @click="addCmsMenu">新增菜单</el-button>
                </div>
                <el-table :data="cmsMenus" border v-loading="cmsMenuLoading">
                  <el-table-column prop="page" label="页面" width="140">
                    <template #default="scope">
                      <el-tag>{{ getCmsPageLabel(scope.row.page) }}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="菜单名称" min-width="180"></el-table-column>
                  <el-table-column prop="sort_order" label="排序" width="100"></el-table-column>
                  <el-table-column prop="article_count" label="文章数" width="100"></el-table-column>
                  <el-table-column label="操作" width="160" fixed="right">
                    <template #default="scope">
                      <el-button @click="editCmsMenu(scope.row)" type="text" :disabled="!canEditPage">编辑</el-button>
                      <el-button @click="deleteCmsMenu(scope.row)" type="text" :disabled="!canEditPage">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  style="margin-top: 16px; text-align: right"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="cmsMenuTotal"
                  :page-sizes="[20, 50, 100]"
                  :current-page="cmsMenuCurrentPage"
                  :page-size="cmsMenuPageSize"
                  @size-change="handleCmsMenuSizeChange"
                  @current-change="handleCmsMenuCurrentChange"
                ></el-pagination>
              </section>

              <section v-else class="config-section">
                <div class="section-head cms-toolbar">
                  <div class="cms-actions">
                    <el-select v-model="cmsFilter.page" placeholder="页面" style="width: 180px" @change="handleCmsFilterPageChange">
                      <el-option label="全部页面" value=""></el-option>
                      <el-option label="场景案例（/feature）" value="feature"></el-option>
                      <el-option label="功能介绍（/intro）" value="intro"></el-option>
                    </el-select>
                    <el-select v-model="cmsFilter.menu" clearable placeholder="菜单" style="width: 180px" @change="resetCmsPage">
                      <el-option label="全部菜单" value=""></el-option>
                      <el-option
                        v-for="item in cmsFilterMenuOptions"
                        :key="getCmsMenuKey(item)"
                        :label="item.name"
                        :value="item.name"
                      ></el-option>
                    </el-select>
                    <el-input
                      v-model="cmsFilter.keyword"
                      clearable
                      placeholder="搜索标题/slug/简介"
                      style="width: 220px"
                      @keyup.enter="resetCmsPage"
                      @clear="resetCmsPage"
                    ></el-input>
                    <el-button @click="queryCmsData">刷新</el-button>
                  </div>
                  <el-button type="primary" :disabled="!canEditPage" @click="addCmsContent">新增文章</el-button>
                </div>
                <el-table :data="cmsData" border v-loading="cmsLoading">
                  <el-table-column prop="page" label="页面" width="120">
                    <template #default="scope">
                      <el-tag>{{ getCmsPageLabel(scope.row.page) }}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="category" label="菜单" width="150"></el-table-column>
                  <el-table-column prop="title" label="Title" min-width="180"></el-table-column>
                  <el-table-column prop="slug" label="Slug" width="180"></el-table-column>
                  <el-table-column prop="description" label="简介" min-width="220" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="keywords" label="关键字" min-width="180" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="sort_order" label="排序" width="90"></el-table-column>
                  <el-table-column label="状态" width="90">
                    <template #default="scope">
                      <el-tag :type="scope.row.published ? 'success' : 'info'">
                        {{ scope.row.published ? '已发布' : '草稿' }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="260" fixed="right">
                    <template #default="scope">
                      <el-button @click="editCmsContent(scope.row)" type="text" :disabled="!canEditPage">编辑</el-button>
                      <el-button @click="publishCmsContent(scope.row, !scope.row.published)" type="text" :disabled="!canEditPage">
                        {{ scope.row.published ? '下线' : '发布' }}
                      </el-button>
                      <el-button @click="openCmsContent(scope.row)" type="text">查看</el-button>
                      <el-button @click="deleteCmsContent(scope.row)" type="text" :disabled="!canEditPage">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  style="margin-top: 16px; text-align: right"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="cmsTotal"
                  :page-sizes="[20, 50, 100]"
                  :current-page="cmsCurrentPage"
                  :page-size="cmsPageSize"
                  @size-change="handleCmsSizeChange"
                  @current-change="handleCmsCurrentChange"
                ></el-pagination>
              </section>
            </div>

            <div v-else class="block w-full px-6 pb-8">
              <section class="config-section">
                <div class="section-head">
                  <div>
                    <h4>线上配置</h4>
                    <p>当前线上用户可见配置。预发布配置或默认配置发布后会覆盖线上配置。</p>
                  </div>
                  <el-button @click="queryData">刷新</el-button>
                </div>
                <el-table :data="productionData" border>
                  <el-table-column prop="name" label="配置名称" width="150"></el-table-column>
                  <el-table-column label="Banner 图" min-width="180">
                    <template #default="scope">
                      <a :href="scope.row.banner_url" target="_blank">{{ scope.row.banner_url || '-' }}</a>
                    </template>
                  </el-table-column>
                  <el-table-column prop="banner_height" label="Banner 高度" width="120"></el-table-column>
                  <el-table-column prop="banner_gap" label="Banner 间距" width="120"></el-table-column>
                  <el-table-column label="点击跳转" width="120">
                    <template #default="scope">
                      <el-tag :type="scope.row.enable_jump ? 'success' : 'info'">
                        {{ scope.row.enable_jump ? '支持' : '不支持' }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="miniapp_id" label="小程序 ID" width="160"></el-table-column>
                  <el-table-column prop="path" label="Path" min-width="160"></el-table-column>
                  <el-table-column label="创建入口背景图" min-width="180">
                    <template #default="scope">
                      <a :href="scope.row.create_entry_bg_url" target="_blank">{{ scope.row.create_entry_bg_url || '-' }}</a>
                    </template>
                  </el-table-column>
                </el-table>
              </section>

              <section class="config-section">
                <div class="section-head">
                  <div>
                    <h4>默认配置</h4>
                    <p>用于兜底展示，可直接编辑保存，也可以直接发布到生产。</p>
                  </div>
                  <div>
                    <el-button type="primary" :disabled="!canEditPage" @click="editDefaultConfig">编辑默认配置</el-button>
                    <el-button
                      type="success"
                      :disabled="!defaultData.length || !canEditPage"
                      @click="publishConfig(defaultData[0])"
                    >发布生产</el-button>
                  </div>
                </div>
                <el-table :data="defaultData" border>
                  <el-table-column prop="name" label="配置名称" width="150"></el-table-column>
                  <el-table-column label="Banner 图" min-width="180">
                    <template #default="scope">
                      <a :href="scope.row.banner_url" target="_blank">{{ scope.row.banner_url || '-' }}</a>
                    </template>
                  </el-table-column>
                  <el-table-column prop="banner_height" label="Banner 高度" width="120"></el-table-column>
                  <el-table-column prop="banner_gap" label="Banner 间距" width="120"></el-table-column>
                  <el-table-column label="点击跳转" width="120">
                    <template #default="scope">
                      <el-tag :type="scope.row.enable_jump ? 'success' : 'info'">
                        {{ scope.row.enable_jump ? '支持' : '不支持' }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="miniapp_id" label="小程序 ID" width="160"></el-table-column>
                  <el-table-column prop="path" label="Path" min-width="160"></el-table-column>
                  <el-table-column label="创建入口背景图" min-width="180">
                    <template #default="scope">
                      <a :href="scope.row.create_entry_bg_url" target="_blank">{{ scope.row.create_entry_bg_url || '-' }}</a>
                    </template>
                  </el-table-column>
                </el-table>
              </section>

              <section class="config-section">
                <div class="section-head">
                  <div>
                    <h4>预发布配置</h4>
                    <p>测试配置发布后会进入预发布，确认无误后再发布到生产。</p>
                  </div>
                  <el-button
                    v-if="!preReleaseData.length"
                    type="primary"
                    :disabled="!canEditPage"
                    @click="addPreReleaseConfig"
                  >新增预发布配置</el-button>
                </div>
                <el-table :data="preReleaseData" border>
                  <el-table-column prop="name" label="配置名称" width="150"></el-table-column>
                  <el-table-column label="Banner 图" min-width="180">
                    <template #default="scope">
                      <a :href="scope.row.banner_url" target="_blank">{{ scope.row.banner_url || '-' }}</a>
                    </template>
                  </el-table-column>
                  <el-table-column prop="banner_height" label="Banner 高度" width="120"></el-table-column>
                  <el-table-column prop="banner_gap" label="Banner 间距" width="120"></el-table-column>
                  <el-table-column label="点击跳转" width="120">
                    <template #default="scope">
                      <el-tag :type="scope.row.enable_jump ? 'success' : 'info'">
                        {{ scope.row.enable_jump ? '支持' : '不支持' }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="miniapp_id" label="小程序 ID" width="160"></el-table-column>
                  <el-table-column prop="path" label="Path" min-width="160"></el-table-column>
                  <el-table-column label="创建入口背景图" min-width="180">
                    <template #default="scope">
                      <a :href="scope.row.create_entry_bg_url" target="_blank">{{ scope.row.create_entry_bg_url || '-' }}</a>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="140" fixed="right">
                    <template #default="scope">
                      <el-button @click="editPreReleaseConfig(scope.row)" type="text" :disabled="!canEditPage">编辑</el-button>
                      <el-button @click="publishConfig(scope.row)" type="text" :disabled="!canEditPage">发布生产</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </section>

              <section class="config-section">
                <div class="section-head">
                  <div>
                    <h4>测试配置</h4>
                    <p>可以创建多条测试配置，验证无误后发布到预发布。</p>
                  </div>
                  <el-button type="primary" :disabled="!canEditPage" @click="addTestConfig">新增测试配置</el-button>
                </div>
                <el-table :data="testData" border v-loading="loading">
                  <el-table-column prop="name" label="配置名称" width="150"></el-table-column>
                  <el-table-column label="Banner 图" min-width="180">
                    <template #default="scope">
                      <a :href="scope.row.banner_url" target="_blank">{{ scope.row.banner_url || '-' }}</a>
                    </template>
                  </el-table-column>
                  <el-table-column prop="banner_height" label="高度" width="90"></el-table-column>
                  <el-table-column prop="banner_gap" label="间距" width="90"></el-table-column>
                  <el-table-column label="点击跳转" width="100">
                    <template #default="scope">
                      <el-tag :type="scope.row.enable_jump ? 'success' : 'info'">
                        {{ scope.row.enable_jump ? '支持' : '不支持' }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="miniapp_id" label="小程序 ID" width="150"></el-table-column>
                  <el-table-column prop="path" label="Path" min-width="150"></el-table-column>
                  <el-table-column label="创建入口背景图" min-width="180">
                    <template #default="scope">
                      <a :href="scope.row.create_entry_bg_url" target="_blank">{{ scope.row.create_entry_bg_url || '-' }}</a>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="180" fixed="right">
                    <template #default="scope">
                      <el-button @click="editTestConfig(scope.row)" type="text" :disabled="!canEditPage">编辑</el-button>
                      <el-button @click="publishConfig(scope.row)" type="text" :disabled="!canEditPage">发布预发布</el-button>
                      <el-button @click="deleteConfig(scope.row)" type="text" :disabled="!canEditPage">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  style="margin-top: 16px; text-align: right"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="testTotal"
                  :page-sizes="[20, 50, 100]"
                  :current-page="currentPage"
                  :page-size="pageSize"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                ></el-pagination>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog v-if="isCmsMenuMode" :title="cmsMenuDialogTitle" :close-on-click-modal="false" v-model="cmsMenuFormVisible" width="520px">
      <el-form ref="cmsMenuFormRef" :model="cmsMenuForm" label-width="100px">
        <el-form-item label="页面">
          <el-select v-model="cmsMenuForm.page" placeholder="请选择页面" style="width: 260px">
            <el-option label="场景案例（PC /feature）" value="feature"></el-option>
            <el-option label="功能介绍（PC /intro）" value="intro"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单名称">
          <el-input v-model="cmsMenuForm.name" placeholder="例如 餐饮与零售门店"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="cmsMenuForm.sort_order" controls-position="right"></el-input-number>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="cmsMenuFormVisible = false">取消</el-button>
          <el-button type="primary" :disabled="!canEditPage" @click="saveCmsMenu">保存</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-if="isCmsArticleMode" :title="cmsDialogTitle" :close-on-click-modal="false" v-model="cmsFormVisible" width="860px">
      <el-form ref="cmsFormRef" class="cms-article-form" :model="cmsForm" label-width="110px">
        <el-form-item label="页面">
          <el-select v-model="cmsForm.page" class="cms-form-control" :disabled="cmsLinkLocked" placeholder="请选择页面" @change="handleCmsFormPageChange">
            <el-option label="场景案例（PC /feature）" value="feature"></el-option>
            <el-option label="功能介绍（PC /intro）" value="intro"></el-option>
          </el-select>
          <div class="form-tip">页面 + Slug 组成 PC 访问链接。文章发布后链接固定，不允许再修改。</div>
        </el-form-item>
        <el-form-item label="菜单">
          <el-select v-model="cmsForm.category" class="cms-form-control" placeholder="请选择归属菜单">
            <el-option
              v-for="item in cmsFormMenuOptions"
              :key="getCmsMenuKey(item)"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
          <div class="form-tip">文章标题会展示在该菜单下；没有菜单时请先到 CMS / 菜单列表新增。</div>
        </el-form-item>
        <el-form-item label="Slug">
          <el-input
            v-model="cmsForm.slug"
            class="cms-form-control"
            :disabled="cmsLinkLocked"
            placeholder="英文、数字、中划线或下划线，例如 case-retail-store"
          ></el-input>
        </el-form-item>
        <el-form-item label="Title">
          <el-input v-model="cmsForm.title" class="cms-form-control" placeholder="用于页面 H1 和 SEO title"></el-input>
        </el-form-item>
        <el-form-item label="简介">
          <el-input v-model="cmsForm.description" class="cms-form-control" type="textarea" :rows="3" placeholder="用于文章摘要和 SEO description"></el-input>
        </el-form-item>
        <el-form-item label="关键字">
          <el-input v-model="cmsForm.keywords" class="cms-form-control" placeholder="用英文逗号或中文逗号分隔"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="cmsForm.sort_order" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="MD 内容">
          <el-upload
            name="file"
            class="cms-md-uploader"
            drag
            action="#"
            accept=".md,.markdown,text/markdown,text/plain"
            :show-file-list="false"
            :before-upload="beforeCmsMarkdownUpload"
          >
            <div class="cms-md-upload-content">
              <i class="fas fa-file-alt cms-md-upload-icon"></i>
              <div class="cms-md-upload-text">拖拽 MD 文件到这里，或点击选择文件</div>
            </div>
          </el-upload>
          <div class="form-tip">MD 从正文开始，不要写 # Title；页面标题使用上方 Title 字段。</div>
          <el-input
            v-model="cmsForm.markdown"
            class="cms-form-control cms-form-control-wide"
            type="textarea"
            :rows="18"
            :placeholder="cmsMarkdownPlaceholder"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="cmsFormVisible = false">取消</el-button>
          <el-button type="primary" :disabled="!canEditPage" @click="saveCmsContent">保存</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-if="!isCmsMode" :title="dialogTitle" :close-on-click-modal="false" v-model="formVisible" width="640px">
      <el-form ref="configForm" :model="form" label-width="130px">
        <el-form-item label="配置名称">
          <el-input v-model="form.name" placeholder="请输入配置名称"></el-input>
        </el-form-item>
        <el-form-item label="首页 Banner 图">
          <el-input v-model="form.banner_url" placeholder="请输入图片 URL"></el-input>
        </el-form-item>
        <el-form-item label="Banner 高度">
          <el-input-number v-model="form.banner_height" :min="0" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="Banner 间距">
          <el-input-number v-model="form.banner_gap" :min="0" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="支持点击跳转">
          <el-switch v-model="form.enable_jump"></el-switch>
        </el-form-item>
        <template v-if="form.enable_jump">
          <el-form-item label="小程序 ID">
            <el-input v-model="form.miniapp_id" placeholder="请输入小程序 ID"></el-input>
          </el-form-item>
          <el-form-item label="Path">
            <el-input v-model="form.path" placeholder="请输入小程序 path"></el-input>
          </el-form-item>
        </template>
        <el-form-item label="创建入口背景图">
          <el-input v-model="form.create_entry_bg_url" placeholder="请输入图片 URL"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" :disabled="!canEditPage" @click="saveConfig">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo } from "@/utils/auth.js";
import { MENU_PERMISSION_KEYS, canEdit } from "@/utils/rbac.js";

const PROD_PC_SITE_ORIGIN = "https://52choujiang.cn";
const LOCAL_PC_SITE_PORT = process.env.VUE_APP_PC_SITE_LOCAL_PORT || "5173";
const CMS_PAGE_PATH_MAP = {
  feature: "/feature",
  intro: "/intro"
};

function getPcSiteOrigin() {
  if (process.env.VUE_APP_PC_SITE_ORIGIN) {
    return process.env.VUE_APP_PC_SITE_ORIGIN;
  }
  if (process.env.NODE_ENV === "production" || typeof window === "undefined") {
    return PROD_PC_SITE_ORIGIN;
  }
  return `${window.location.protocol}//${window.location.hostname}:${LOCAL_PC_SITE_PORT}`;
}

function normalizeCmsMarkdown(markdown) {
  const lines = String(markdown || '').replace(/\r\n/g, '\n').split('\n');
  const firstContentIndex = lines.findIndex((line) => line.trim());
  if (firstContentIndex >= 0 && /^#(?!#)\s+/.test(lines[firstContentIndex].trim())) {
    lines.splice(firstContentIndex, 1);
    if (lines[firstContentIndex] !== undefined && !lines[firstContentIndex].trim()) {
      lines.splice(firstContentIndex, 1);
    }
  }
  return lines.join('\n');
}

const emptyConfig = {
  id: '',
  name: '',
  env: 'test',
  banner_url: '',
  banner_height: 0,
  banner_gap: 0,
  enable_jump: false,
  miniapp_id: '',
  path: '',
  create_entry_bg_url: ''
};

const emptyCmsForm = {
  id: '',
  page: 'feature',
  slug: '',
  title: '',
  description: '',
  keywords: '',
  category: '',
  markdown: '',
  sort_order: 0,
  published: false,
  published_at: 0
};

const emptyCmsMenuForm = {
  id: '',
  page: 'feature',
  name: '',
  sort_order: 0
};

export default {
  name: 'HomeBanner',
  data() {
    return {
      loading: false,
      productionData: [],
      defaultData: [],
      preReleaseData: [],
      testData: [],
      testTotal: 0,
      currentPage: 1,
      pageSize: 20,
      formVisible: false,
      form: { ...emptyConfig },
      cmsLoading: false,
      cmsData: [],
      cmsTotal: 0,
      cmsCurrentPage: 1,
      cmsPageSize: 20,
      cmsFilter: {
        page: '',
        menu: '',
        keyword: ''
      },
      cmsFormVisible: false,
      cmsForm: { ...emptyCmsForm },
      cmsMenuLoading: false,
      cmsMenus: [],
      cmsAllMenus: [],
      cmsMenuTotal: 0,
      cmsMenuCurrentPage: 1,
      cmsMenuPageSize: 20,
      cmsMenuFilter: {
        page: '',
        keyword: ''
      },
      cmsMenuFormVisible: false,
      cmsMenuForm: { ...emptyCmsMenuForm }
    };
  },
  computed: {
    isCmsMode() {
      return this.$route.path.includes('/admin/cms') || this.$route.path.includes('/pc-cms');
    },
    isCmsMenuMode() {
      return this.$route.path.includes('/admin/cms/menus');
    },
    isCmsArticleMode() {
      return this.$route.path.includes('/admin/cms/articles') || this.$route.path.includes('/pc-cms');
    },
    pageTitle() {
      if (this.isCmsMenuMode) {
        return 'CMS 菜单列表';
      }
      if (this.isCmsArticleMode) {
        return 'CMS 文章列表';
      }
      return '首页 Banner';
    },
    canEditPage() {
      let permissionKey = MENU_PERMISSION_KEYS.MATERIALS_HOME_BANNER;
      if (this.isCmsMenuMode) {
        permissionKey = MENU_PERMISSION_KEYS.CMS_MENU_LIST;
      } else if (this.isCmsArticleMode) {
        permissionKey = MENU_PERMISSION_KEYS.CMS_ARTICLE_LIST;
      }
      return canEdit(getUserInfo(), permissionKey);
    },
    dialogTitle() {
      if (this.form.env === 'default') {
        return '编辑默认配置';
      }
      if (this.form.env === 'pre-release') {
        return this.form.id ? '编辑预发布配置' : '新增预发布配置';
      }
      return this.form.id ? '编辑测试配置' : '新增测试配置';
    },
    cmsDialogTitle() {
      return this.cmsForm.id ? '编辑 PC 内容' : '新增 PC 内容';
    },
    cmsMenuDialogTitle() {
      return this.cmsMenuForm.id ? '编辑菜单' : '新增菜单';
    },
    cmsFilterMenuOptions() {
      return this.getCmsMenuOptions(this.cmsFilter.page);
    },
    cmsFormMenuOptions() {
      return this.getCmsMenuOptions(this.cmsForm.page);
    },
    cmsLinkLocked() {
      return Boolean(this.cmsForm.id && (this.cmsForm.published || this.cmsForm.published_at));
    },
    cmsMarkdownPlaceholder() {
      return [
        '正文从内容开始，不要写 # Title；大段落标题用 ##。',
        '支持二级标题、段落、列表、引用、链接、图片等基础 Markdown。',
        '为了 GEO / AI 搜索，建议在正文末尾添加 FAQ：',
        '',
        '## FAQ',
        '### 抽奖活动适合哪些场景？',
        '适合门店引流、私域社群、会员福利等场景。',
        '',
        '### 如何提高用户参与率？',
        '可以在文章里说明活动入口、奖品设置和兑奖流程。'
      ].join('\n');
    }
  },
  mounted() {
    this.queryCurrentPageData();
  },
  watch: {
    '$route.path'() {
      this.queryCurrentPageData();
    }
  },
  methods: {
    queryCurrentPageData() {
      if (this.isCmsMenuMode) {
        this.queryCmsMenuData();
      } else if (this.isCmsArticleMode) {
        this.queryCmsMenuOptions();
        this.queryCmsData();
      } else {
        this.queryData();
      }
    },
    queryCmsData() {
      this.cmsLoading = true;
      this.$$getPcCmsList({
        page: this.cmsCurrentPage,
        page_size: this.cmsPageSize,
        cms_page: this.cmsFilter.page,
        menu: this.cmsFilter.menu,
        keyword: this.cmsFilter.keyword
      }, (res) => {
        this.cmsLoading = false;
        if (res.sta === 0) {
          this.cmsData = res.data && Array.isArray(res.data.list) ? res.data.list : [];
          this.cmsTotal = res.data ? (res.data.total || 0) : 0;
        } else {
          this.$message.error(res.msg);
        }
      }, () => {
        this.cmsLoading = false;
        this.$message.error('数据请求失败');
      });
    },
    queryCmsMenuData() {
      this.cmsMenuLoading = true;
      this.$$getPcCmsMenuList({
        page: this.cmsMenuCurrentPage,
        page_size: this.cmsMenuPageSize,
        cms_page: this.cmsMenuFilter.page,
        keyword: this.cmsMenuFilter.keyword
      }, (res) => {
        this.cmsMenuLoading = false;
        if (res.sta === 0) {
          this.cmsMenus = res.data && Array.isArray(res.data.list) ? res.data.list : [];
          this.cmsMenuTotal = res.data ? (res.data.total || 0) : 0;
          this.queryCmsMenuOptions();
        } else {
          this.$message.error(res.msg);
        }
      }, () => {
        this.cmsMenuLoading = false;
        this.$message.error('数据请求失败');
      });
    },
    queryCmsMenuOptions() {
      this.$$getPcCmsMenuList({
        page: 1,
        page_size: 500
      }, (res) => {
        if (res.sta === 0) {
          this.cmsAllMenus = res.data && Array.isArray(res.data.list) ? res.data.list : [];
          if (this.cmsFilter.menu && !this.getCmsMenuOptions(this.cmsFilter.page).some((item) => item.name === this.cmsFilter.menu)) {
            this.cmsFilter.menu = '';
          }
          if (this.cmsForm.category && !this.getCmsMenuOptions(this.cmsForm.page).some((item) => item.name === this.cmsForm.category)) {
            this.cmsForm.category = '';
          }
        }
      });
    },
    resetCmsPage() {
      this.cmsCurrentPage = 1;
      this.queryCmsData();
    },
    resetCmsMenuPage() {
      this.cmsMenuCurrentPage = 1;
      this.queryCmsMenuData();
    },
    handleCmsFilterPageChange() {
      this.cmsFilter.menu = '';
      this.resetCmsPage();
    },
    handleCmsSizeChange(val) {
      this.cmsPageSize = val;
      this.cmsCurrentPage = 1;
      this.queryCmsData();
    },
    handleCmsCurrentChange(val) {
      this.cmsCurrentPage = val;
      this.queryCmsData();
    },
    handleCmsMenuSizeChange(val) {
      this.cmsMenuPageSize = val;
      this.cmsMenuCurrentPage = 1;
      this.queryCmsMenuData();
    },
    handleCmsMenuCurrentChange(val) {
      this.cmsMenuCurrentPage = val;
      this.queryCmsMenuData();
    },
    getCmsMenuKey(item) {
      return String(item._id || item.id || `${item.page}-${item.name}`);
    },
    getCmsMenuOptions(page) {
      return this.cmsAllMenus.filter((item) => !page || item.page === page);
    },
    getCmsPageLabel(page) {
      if (page === 'feature') {
        return '场景案例';
      }
      if (page === 'intro') {
        return '功能介绍';
      }
      return page || '-';
    },
    getCmsContentPath(item) {
      const basePath = CMS_PAGE_PATH_MAP[item.page] || '';
      return item.slug ? `${basePath}/${item.slug}` : '-';
    },
    getCmsContentUrl(item) {
      const path = this.getCmsContentPath(item);
      const origin = getPcSiteOrigin();
      return path === '-' ? origin : `${origin}${path}`;
    },
    openCmsContent(item) {
      const url = this.getCmsContentUrl(item);
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    addCmsMenu() {
      if (!this.ensureEditable()) {
        return;
      }
      this.cmsMenuForm = {
        ...emptyCmsMenuForm,
        page: this.cmsMenuFilter.page || 'feature'
      };
      this.cmsMenuFormVisible = true;
    },
    editCmsMenu(item) {
      if (!this.ensureEditable()) {
        return;
      }
      this.cmsMenuForm = {
        ...emptyCmsMenuForm,
        ...item,
        id: item._id || item.id,
        sort_order: Number(item.sort_order || 0)
      };
      this.cmsMenuFormVisible = true;
    },
    validateCmsMenuForm() {
      if (!this.cmsMenuForm.page) {
        this.$message.error('请选择页面');
        return false;
      }
      if (!this.cmsMenuForm.name) {
        this.$message.error('请输入菜单名称');
        return false;
      }
      return true;
    },
    saveCmsMenu() {
      if (!this.ensureEditable()) {
        return;
      }
      if (!this.validateCmsMenuForm()) {
        return;
      }
      const payload = {
        id: this.cmsMenuForm.id,
        page: this.cmsMenuForm.page,
        name: this.cmsMenuForm.name,
        sort_order: this.cmsMenuForm.sort_order || 0
      };
      const api = payload.id ? this.$$updatePcCmsMenu : this.$$addPcCmsMenu;
      api(payload, (res) => {
        if (res.sta === 0) {
          this.cmsMenuFormVisible = false;
          this.queryCmsMenuData();
        } else {
          this.$message.error(res.msg);
        }
      }, () => {
        this.$message.error('数据请求失败');
      });
    },
    deleteCmsMenu(item) {
      if (!this.ensureEditable()) {
        return;
      }
      this.$confirm('确定删除该菜单？菜单下已有文章时不能删除。', '提示').then(() => {
        this.$$deletePcCmsMenu({
          data: {
            id: item._id || item.id
          }
        }, (res) => {
          if (res.sta === 0) {
            this.queryCmsMenuData();
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('数据请求失败');
        });
      });
    },
    handleCmsFormPageChange() {
      if (!this.cmsFormMenuOptions.some((item) => item.name === this.cmsForm.category)) {
        this.cmsForm.category = '';
      }
    },
    addCmsContent() {
      if (!this.ensureEditable()) {
        return;
      }
      if (!this.cmsAllMenus.length) {
        this.$message.warning('请先在 CMS / 菜单列表新增菜单');
        return;
      }
      this.cmsForm = {
        ...emptyCmsForm,
        page: this.cmsFilter.page || 'feature',
        category: this.cmsFilter.menu || ''
      };
      this.cmsFormVisible = true;
    },
    editCmsContent(item) {
      if (!this.ensureEditable()) {
        return;
      }
      this.cmsForm = {
        ...emptyCmsForm,
        ...item,
        id: item._id || item.id,
        keywords: item.keywords || '',
        sort_order: Number(item.sort_order || 0)
      };
      this.cmsFormVisible = true;
    },
    validateCmsForm() {
      const slugPattern = /^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$/;
      if (!this.cmsForm.page) {
        this.$message.error('请选择页面');
        return false;
      }
      if (!slugPattern.test(this.cmsForm.slug || '')) {
        this.$message.error('Slug 只能使用 1-64 位英文、数字、中划线或下划线');
        return false;
      }
      if (!this.cmsForm.title) {
        this.$message.error('请输入文章 title');
        return false;
      }
      if (!this.cmsForm.description) {
        this.$message.error('请输入文章简介');
        return false;
      }
      if (!this.cmsForm.keywords) {
        this.$message.error('请输入文章关键字');
        return false;
      }
      if (!this.cmsForm.category) {
        this.$message.error('请选择归属菜单');
        return false;
      }
      if (!this.cmsForm.markdown) {
        this.$message.error('请输入 MD 内容');
        return false;
      }
      if (!normalizeCmsMarkdown(this.cmsForm.markdown).trim()) {
        this.$message.error('请输入 MD 正文内容');
        return false;
      }
      return true;
    },
    beforeCmsMarkdownUpload(file) {
      const fileName = file && file.name ? file.name : '';
      const fileType = file && file.type ? file.type : '';
      const isMarkdown = /\.(md|markdown)$/i.test(fileName)
        || ['text/markdown', 'text/x-markdown', 'text/plain', ''].includes(fileType);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isMarkdown) {
        this.$message.error('请选择 .md 或 .markdown 文件');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('MD 文件大小不能超过 2MB');
        return false;
      }
      const reader = new FileReader();
      reader.onload = () => {
        const rawMarkdown = String(reader.result || '');
        const normalizedMarkdown = normalizeCmsMarkdown(rawMarkdown);
        this.cmsForm.markdown = normalizedMarkdown;
        this.$message.success(rawMarkdown === normalizedMarkdown ? 'MD 文件已导入' : 'MD 文件已导入，已移除开头 Title');
      };
      reader.onerror = () => {
        this.$message.error('MD 文件读取失败');
      };
      reader.readAsText(file, 'utf-8');
      return false;
    },
    getCmsPayload() {
      return {
        id: this.cmsForm.id,
        page: this.cmsForm.page,
        slug: this.cmsForm.slug,
        title: this.cmsForm.title,
        description: this.cmsForm.description,
        keywords: this.cmsForm.keywords,
        category: this.cmsForm.category,
        markdown: normalizeCmsMarkdown(this.cmsForm.markdown),
        sort_order: this.cmsForm.sort_order || 0
      };
    },
    saveCmsContent() {
      if (!this.ensureEditable()) {
        return;
      }
      if (!this.validateCmsForm()) {
        return;
      }
      const wasPublished = Boolean(this.cmsForm.id && (this.cmsForm.published || this.cmsForm.published_at));
      this.cmsForm.markdown = normalizeCmsMarkdown(this.cmsForm.markdown);
      const payload = this.getCmsPayload();
      const api = payload.id ? this.$$updatePcCms : this.$$addPcCms;
      api(payload, (res) => {
        if (res.sta === 0) {
          this.cmsFormVisible = false;
          this.$message.success(wasPublished ? '已保存成功，已同步更新 PC' : '已保存成功');
          this.queryCmsData();
        } else {
          this.$message.error(res.msg);
        }
      }, () => {
        this.$message.error('数据请求失败');
      });
    },
    publishCmsContent(item, published) {
      if (!this.ensureEditable()) {
        return;
      }
      const actionText = published ? '发布该文章到 PC' : '下线该文章';
      this.$confirm(`确定${actionText}？`, '提示').then(() => {
        this.$$publishPcCms({
          id: item._id || item.id,
          published
        }, (res) => {
          if (res.sta === 0) {
            this.queryCmsData();
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('数据请求失败');
        });
      });
    },
    deleteCmsContent(item) {
      if (!this.ensureEditable()) {
        return;
      }
      this.$confirm('确定删除该文章？', '提示').then(() => {
        this.$$deletePcCms({
          data: {
            id: item._id || item.id
          }
        }, (res) => {
          if (res.sta === 0) {
            this.queryCmsData();
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('数据请求失败');
        });
      });
    },
    queryData() {
      this.loading = true;
      this.$$getHomeBannerList({
        page: this.currentPage,
        page_size: this.pageSize
      }, (res) => {
        this.loading = false;
        if (res.sta === 0) {
          this.productionData = this.getSingleConfigList(res.data.production);
          this.defaultData = this.getSingleConfigList(res.data.default);
          this.preReleaseData = this.getSingleConfigList(res.data.pre_release);
          this.testData = res.data.test && Array.isArray(res.data.test.list) ? res.data.test.list : [];
          this.testTotal = res.data.test ? (res.data.test.total || 0) : 0;
        } else {
          this.$message.error(res.msg);
        }
      }, () => {
        this.loading = false;
        this.$message.error('数据请求失败');
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.queryData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryData();
    },
    getSingleConfigList(item) {
      return item && (item._id || item.id) ? [item] : [];
    },
    addTestConfig() {
      if (!this.ensureEditable()) {
        return;
      }
      this.form = {
        ...emptyConfig,
        env: 'test'
      };
      this.formVisible = true;
    },
    addPreReleaseConfig() {
      if (!this.ensureEditable()) {
        return;
      }
      this.form = {
        ...emptyConfig,
        env: 'pre-release'
      };
      this.formVisible = true;
    },
    editDefaultConfig() {
      if (!this.ensureEditable()) {
        return;
      }
      this.form = {
        ...emptyConfig,
        ...this.defaultData[0],
        id: this.defaultData[0] && this.defaultData[0]._id ? this.defaultData[0]._id : this.defaultData[0]?.id,
        env: 'default',
        enable_jump: Boolean(this.defaultData[0] && this.defaultData[0].enable_jump)
      };
      this.formVisible = true;
    },
    editPreReleaseConfig(item) {
      if (!this.ensureEditable()) {
        return;
      }
      this.form = {
        ...emptyConfig,
        ...item,
        id: item._id || item.id,
        env: 'pre-release',
        enable_jump: Boolean(item.enable_jump)
      };
      this.formVisible = true;
    },
    editTestConfig(item) {
      if (!this.ensureEditable()) {
        return;
      }
      this.form = {
        ...emptyConfig,
        ...item,
        id: item._id || item.id,
        env: 'test',
        enable_jump: Boolean(item.enable_jump)
      };
      this.formVisible = true;
    },
    ensureEditable() {
      if (this.canEditPage) {
        return true;
      }

      this.$message.warning(`当前角色无权编辑${this.pageTitle}`);
      return false;
    },
    validateForm() {
      if (!this.form.name) {
        this.$message.error('请输入配置名称');
        return false;
      }
      if (!this.form.banner_url) {
        this.$message.error('请输入首页 Banner 图 URL');
        return false;
      }
      if (!this.form.create_entry_bg_url) {
        this.$message.error('请输入创建入口背景图 URL');
        return false;
      }
      if (this.form.enable_jump && !this.form.miniapp_id) {
        this.$message.error('请输入小程序 ID');
        return false;
      }
      if (this.form.enable_jump && !this.form.path) {
        this.$message.error('请输入小程序 path');
        return false;
      }
      return true;
    },
    getPayload() {
      return {
        id: this.form.id,
        name: this.form.name,
        env: this.form.env,
        banner_url: this.form.banner_url,
        banner_height: this.form.banner_height,
        banner_gap: this.form.banner_gap,
        enable_jump: this.form.enable_jump,
        miniapp_id: this.form.enable_jump ? this.form.miniapp_id : '',
        path: this.form.enable_jump ? this.form.path : '',
        create_entry_bg_url: this.form.create_entry_bg_url
      };
    },
    saveConfig() {
      if (!this.ensureEditable()) {
        return;
      }
      if (!this.validateForm()) {
        return;
      }
      const payload = this.getPayload();
      const api = payload.id ? this.$$updateHomeBanner : this.$$addHomeBanner;
      api(payload, (res) => {
        if (res.sta === 0) {
          this.formVisible = false;
          this.queryData();
        } else {
          this.$message.error(res.msg);
        }
      }, () => {
        this.$message.error('数据请求失败');
      });
    },
    publishConfig(item) {
      if (!this.ensureEditable()) {
        return;
      }
      const env = item.env;
      const actionText = env === 'test' ? '发布该测试配置到预发布' : '发布该配置到生产';
      this.$confirm(`确定${actionText}？`, '提示').then(() => {
        this.$$publishHomeBanner({
          id: item._id || item.id
        }, (res) => {
          if (res.sta === 0) {
            this.queryData();
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('数据请求失败');
        });
      });
    },
    deleteConfig(item) {
      if (!this.ensureEditable()) {
        return;
      }
      this.$confirm('确定删除该测试配置？', '提示').then(() => {
        this.$$deleteHomeBanner({
          data: {
            id: item._id || item.id
          }
        }, (res) => {
          if (res.sta === 0) {
            this.queryData();
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('数据请求失败');
        });
      });
    }
  }
};
</script>

<style scoped>
.config-section {
  margin-top: 24px;
}

.section-head {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 14px;
}

.section-head h4 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.section-head p {
  margin: 8px 0 0;
  color: #6b7280;
  font-size: 14px;
}

.cms-toolbar {
  align-items: center;
}

.cms-toolbar .cms-actions {
  flex: 1;
  justify-content: flex-start;
}

.cms-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
}

.form-tip {
  margin-top: 8px;
  color: #6b7280;
  font-size: 12px;
  line-height: 18px;
}

.cms-article-form :deep(.el-form-item) {
  margin-bottom: 18px;
}

.cms-article-form :deep(.el-form-item__content) {
  display: block;
  font-size: 14px;
  line-height: 20px;
}

.cms-form-control {
  width: min(560px, 100%);
}

.cms-form-control-wide {
  width: 100%;
}

.cms-form-control :deep(.el-input__inner),
.cms-form-control :deep(.el-textarea__inner) {
  font-size: 14px;
}

.cms-md-uploader {
  margin-bottom: 10px;
  width: 100%;
}

.cms-md-uploader :deep(.el-upload) {
  width: 100%;
}

.cms-md-uploader :deep(.el-upload-dragger) {
  width: 100%;
  padding: 14px 16px;
  line-height: 20px;
}

.cms-md-upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.cms-md-upload-icon {
  color: #2563eb;
  font-size: 24px;
}

.cms-md-upload-text {
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

a {
  color: #2563eb;
  word-break: break-all;
}
</style>
